<template>
    <div class="tool_container" id="tool_container">
        <div class="panelcontainer_for_tool">
            <table class="params">
                <tbody>
                    <!-- 1 省份： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="province">省、自治区、直辖市：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="province" @change="provinceChange($event)">
                                    <option v-for="(item, index) in localData" :key="index" :value="index">
                                        {{ item.province }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 2 市、地区、自治州、盟： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="city">市、地区、自治州、盟：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="city" @change="cityChange($event)">
                                    <option v-for="(item, index) in cityList" :key="index" :value="index">{{
                                        item }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 3 县市： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="city">区、县、县级市、旗：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="county" @change="countyChange($event)">
                                    <option v-for="(item, index) in countyList" :key="index" :value="index">{{
                                        item }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 4 乡镇、街道、苏木： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="city">乡镇、街道、苏木：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="town" @change="townChange($event)">
                                    <option v-for="(item, index) in townList" :key="index" :value="index">{{
                                        item }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 5 项目场地类别： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="recurrence_wind">项目场地类别：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="classification"
                                    @change="selectLocation($event, selectedData, 'siteType')">
                                    <option value="0">I0</option>
                                    <option value="1">I1</option>
                                    <option value="2">II</option>
                                    <option value="3">III </option>
                                    <option value="4">IV</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 6 多遇、罕遇地震系数： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="recurrence_wind">
                                多遇地震加速度系数：<br />
                                <span style="font-size: 14px;">(≥1/3)</span>
                            </label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <input type="number" class="input_for_tool" id="frequent_coeff" @keydown="filterNum($event)"
                                    @change="checkNum($event)" v-model="selectedData.frequent_coeff" />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="recurrence_wind">
                                罕遇地震加速度系数： <br />
                                <span style="font-size: 14px;">(1.6~2.3) </span>
                            </label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <input type="number" class="input_for_tool" id="rare_coeff" @keydown="filterNum($event)"
                                    @change="checkNum($event)" v-model="selectedData.rare_coeff" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="content_for_tool">
            <div class="result_container">
                <div class="result_title">
                    <h4>查询结果:</h4>
                </div>
                <div class="result_content">
                    <table class="result_table">

                        <tbody>
                            <tr>
                                <td class="result_td">
                                    <span>项 目</span>
                                </td>
                                <td class="result_td result_td_left">
                                    <span>水平地震影响系数最大值αmax</span>
                                </td>
                                <td class="result_td result_td_left">
                                    <span>特征周期值(s)</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="result_td">
                                    <span>多遇地震</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[0][0] }}</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[0][1] }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="result_td">
                                    <span>设防地震</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[1][0] }}</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[1][1] }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="result_td">
                                    <span>罕遇地震</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[2][0] }}</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[2][1] }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="result_td">
                                    <span>设计基本加速度</span>
                                </td>
                                <td class="result_td result_td_right" colspan="2">
                                    <span>{{ result[3][0] }}g</span>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tips">
                    <p class="tips_text">注:1、根据《中国地震动参数区划图》(GB18306 -2015)和《建筑与市政</p>
                    <p class="tips_text">&ensp;&ensp;&ensp;工程抗震通用规范》(GB55002 -2021)编制。</p>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
export default {
    name: "Seismic_Parameters"
};
</script>

<script setup>
import { _getSeismicLocal, _getSeismicValue } from "@/api/index";
import { reactive, watch } from "vue";
// import { useTempStore } from '@/store/temp';
import Toast from "@/utils/toast";
import { filterNum, checkNum } from "@/utils/number_input.js";
// import { filterNum, checkNum } from "@/utils/number.js";

// 01加载地点数据~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
var localData = reactive([]);
var cityList = reactive([]); // 加载完localData后，默认选择第一个省份的城市数据,后面调用setLocationList函数更新
var countyList = reactive([]); // 加载完localData后，默认选择第一个省份的第一个城市的区县数据,后面调用setLocationList函数更新
var townList = reactive([]); // 加载完localData后，默认选择第一个省份的第一个城市的第一个区县的乡镇、街道、苏木数据,后面调用setLocationList函数更新



_getSeismicLocal().then(
    (res) => {
        if (res.data.message === "ok") {

            let location_data = res.data.data;
            // console.log(res.data.data)
            let len = location_data.length;
            for (let i = 0; i < len; i++) {
                let province = location_data[i].province;
                let data = location_data[i].data;
                let selected = location_data[i].selected;
                let obj = {
                    "province": province,
                    "selected": selected,
                    "data": data,
                };
                localData.push(obj);
            }

            setLocationList(0, 'city', cityList); // 默认选择第一个省份的城市数据
            setLocationList(0, 'county', countyList); // 默认选择第一个省份的第一个城市的区县数据
            setLocationList(0, 'town', townList); // 默认选择第一个省份的第一个城市的第一个区县的乡镇、街道、苏木数据
        }
    }
)



// 02提交的查询参数~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
let selectedData = reactive(
    {
        province: 0,
        city: 0,
        county: 0,
        town: 0,
        siteType: 0,
        frequent_coeff: 0.333,
        rare_coeff: 1.600,
    }
);

// 03数据响应式处理~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function provinceChange(e) {
    selectLocation(e, selectedData, 'province')
    selectedData['city'] = 0;
    selectedData['county'] = 0;
    selectedData['town'] = 0;
    setLocationList(e, 'city', cityList);
    setLocationList(0, 'county', countyList);
    setLocationList(0, 'town', townList);
    setSelectedToZero('city');
    setSelectedToZero('county');
    setSelectedToZero('town');
}
function cityChange(e) {
    selectLocation(e, selectedData, 'city')
    selectedData['county'] = 0;
    selectedData['town'] = 0;
    setLocationList(e, 'county', countyList);
    setLocationList(0, 'town', townList);
    setSelectedToZero('county');
    setSelectedToZero('town');
}
function countyChange(e) {
    selectLocation(e, selectedData, 'county')
    selectedData['town'] = 0;
    setLocationList(e, 'town', townList);
    setSelectedToZero('town');
}
function townChange(e) {
    selectLocation(e, selectedData, 'town')
}


// 04查询结果~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

let result = reactive([['0.167', '0.250',], ['0.500', '0.250',], ['0.900', '0.300',], ['0.20']]);
watch(selectedData,
    (newVal, oldVal) => {
        if (newVal.frequent_coeff == '' || newVal.rare_coeff == '') {
            return
        } else {
            _getSeismicValue(selectedData).then(
                (res) => {
                    if (res.data.message === "ok") {
                        result[0] = res.data.data.frequent_seism;
                        result[0][0] = parseFloat(result[0][0]).toFixed(3);
                        result[0][1] = parseFloat(result[0][1]).toFixed(3);
                        result[1] = res.data.data.basic_seism;
                        result[1][0] = parseFloat(result[1][0]).toFixed(3);
                        result[1][1] = parseFloat(result[1][1]).toFixed(3);
                        result[2] = res.data.data.rare_seism;
                        result[2][0] = parseFloat(result[2][0]).toFixed(3);
                        result[2][1] = parseFloat(result[2][1]).toFixed(3);
                        result[3] = res.data.data.basic_acceleration;
                        result[3][0] = parseFloat(result[3][0]).toFixed(2);

                    } else {
                        Toast(res.data.message, 'tool_container', 50, 1000, true);
                    }
                }
            ).catch(
                (err) => {
                    // console.log(err);
                    Toast('warning, 查询失败！', 'tool_container', 50, 1000, true)
                }
            )
        }
    }
)
//公共函数~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// 1 用选中的省市县乡镇数据设置selectedData~
function selectLocation(e, obj, key) {
    let select = e.target;
    let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
    obj[key] = i;
}
//2 设置市、县、乡镇列表~
function setLocationList(index_or_event, location_key, list_container) {
    let index = 0;
    if (typeof index_or_event === "number" && !isNaN(index_or_event)) {
        index = index_or_event;
    } else if (typeof index_or_event === "object") {
        index = index_or_event.target.selectedIndex;
    }

    let data = []
    let final_data = []
    if (location_key === "city") {
        data = localData[index].data;
        // console.log(data)
        for (let i = 0; i < data.length; i++) {
            final_data.push(data[i].city);
        }
    } else if (location_key === "county") {
        data = localData[selectedData["province"]].data[index].data;

        for (let i = 0; i < data.length; i++) {
            final_data.push(data[i].county);
        }
    } else if (location_key === "town") {
        final_data = localData[selectedData["province"]].data[selectedData["city"]].data[index].town;
    }
    // console.log(final_data)
    // list_container = final_data; // list_container = data;会失去响应式
    list_container.splice(0, list_container.length); // list_container = data;会失去响应式
    for (let i = 0; i < final_data.length; i++) {
        list_container.push(final_data[i]);
    }

}

function setSelectedToZero(id) {
    let select = document.getElementById(id);
    select.selectedIndex = 0;
}

// selected改变SET的值
// function setValue(e, obj, key) {
//     let select = e.target;
//     let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
//     let value = select.options[i].value;
//     obj[key] = value;
// }


// // 防止输入负数、字符~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// var tempStore = 0;
// const saveInitValue = (e) => {
//     tempStore = e.target.value;
//     console.log(tempStore)
// };
// const filterNum = (e, minus = false) => {
//     let prohibit = minus ? ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'] : ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
//     if (e.keyCode == 46 || e.keyCode == 8) {
//         return
//     } else if (!prohibit.includes(e.key)) {
//         e.preventDefault();
//     }
//     // tempStore.value = e.target.value;
// };

// // 不正确的小数点检查~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// const checkNum = (e) => {

//     let obj = document.getElementById(e.target.id)
//     let scale = 3

//     const t = String(obj.value).charAt(0)


//     // obj.value = obj.value.replace(/[^\u4E00-\u9FA5]/g, ""); //清除"数字"和"."以外的字符  keydown已经过滤了
//     obj.value = obj.value.replace(/[^\d.]/g, "");  //j禁止输入中文
//     obj.value = obj.value.replace(/^\./g, ""); //验证第一个字符是数字而不是其他字符
//     obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 不能输入连续的.
//     obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");//清除后面的.
//     var re = new RegExp("^(\\-)*(\\d+)\\.(\\d{" + scale + "}).*$");
//     obj.value = obj.value.replace(re, '$1$2.$3'); //只能输入scale个小数
//     if (obj.value === 0) {
//         obj.value = tempStore;
//     }
//     if (t === '-') {
//         obj.value = '-' + obj.value;
//     }

//     let event = document.createEvent('Event')
//     event.initEvent('input', true, true)
//     event.eventType = 'message'
//     obj.dispatchEvent(event)
// };


</script>



<style scoped>
/* panel区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.tool_container {
    background-color: white;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    /* flex-direction: column; */

    /* align-items: center; */
    /* position: relative; */
    opacity: 0.7;
    overflow-y: scroll;
    scrollbar-width: none;
}

/* .tool_container::-webkit-scrollbar {
    display: none;
} */

.panelcontainer_for_tool {
    /* width: 375px; */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 22px;
}

table {
    table-layout: fixed;
    padding: 0;
    width: 100% !important;
}

table .label_for_tool {
    width: 160px;
}

table .text_for_tool {
    width: 220px;
}

/* table tr {
    width: 100%;
} */

table tr td {
    padding: 0;

}

label {
    padding: 0 !important;
    margin-top: 15px;
    font-size: 15px;
}

.panel_for_tool {
    height: 37px;
    width: 220px;
    padding: 0px 20px;
    border: 1px solid var(--secondary-color);
    border-radius: 25px;
    margin-top: 15px;
    /* margin-bottom: 5px; */
    box-shadow: 6px 6px 3px rgba(0, 0, 0, 0.3), -4px -4px 4px rgba(194, 185, 185, 0.4);
    display: flex;
    justify-content: center;
}

.select_for_tool {
    width: 200px;
    height: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    background-color: white;
    padding-top: 2px;
}


input[type="number"],
input[type="text"] {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    background-color: white;
    text-align: center;
    /* ime-mode: disabled; */
}

/* content区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.content_for_tool {
    width: 100%;
    height: 250px;
    /* position: relative; */
    /* height: calc(100%); */
    /* overflow: auto; */
    /* margin-top: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    color: black !important;
}

.result_container {
    width: 400px;
    margin-bottom: 10px;

}

.result_table {
    margin-top: 3px;
    width: 300px;
    border-collapse: collapse;
}

.result_table td {
    border: 1px solid var(--secondary-color);
    width: 50%;
    padding: 5px;
    font-size: 16px;
}

.result_td_right {
    font-size: 18px !important;
    line-height: 20px;
}

.tips {
    font-size: 12px;
    text-align: left;
}

.tips p {
    padding-bottom: 3px;
}
</style>
